export const initOptions = {
    debug: false,
};
